import { createAsyncThunk } from '@reduxjs/toolkit';
import { verifyCode } from 'services/PasswordReset';

export const doVerifyCode = createAsyncThunk(
    'recovery/doVerifyCode',
    async (params) => {
        return await verifyCode(params);
    }
);

// Verify code
export const doVerifyCodeReducer = {
    [doVerifyCode.pending]: (state) => {
        state.recoveryError = false;
    },

    [doVerifyCode.fulfilled]: (state, action) => {
        if (action.payload.error === false) {
            state.step3Done = true;
        } else {
            state.recoveryError = action.payload.error;
        }
    },

    [doVerifyCode.rejected]: (state) => {
        state.recoveryError = 'error.internal';
    },
};
